// extracted by mini-css-extract-plugin
export var logo = "_kl-2";
export var logoWrapper = "_kl-1";
export var strip = "_kl-0";